module.exports = __webpack_public_path__ + "img/modelo-cantina-gal-11.38c83022.jpg";